import { lazy } from "react";
import { type RouteObject, Navigate } from "react-router";
import { ProtectedRoute } from "@/features/auth/ProtectedRoute";
/**
* Define el árbol de rutas con lazy imports.
*
* Reglas:
* - Rutas públicas arriba (login, signup, terms, privacy, auth/callback)
* - Rutas autenticadas envueltas en <ProtectedRoute /> y luego <Layout />
* - Todo lazy excepto ProtectedRoute (es trivial, no vale code-splittear)
* - `*` al final captura 404 y redirige a /dashboard si hay sesión, /login si no
* (lo decide ProtectedRoute → Navigate)
*/
const LoginPage = lazy(() => import("@/pages/Login"));
const SignupPage = lazy(() => import("@/pages/Signup"));
const ForgotPasswordPage = lazy(() => import("@/pages/ForgotPassword"));
const ResetPasswordPage = lazy(() => import("@/pages/ResetPassword"));
const AuthCallbackPage = lazy(() => import("@/pages/AuthCallback"));
const TermsPage = lazy(() => import("@/pages/Terms"));
const PrivacyPage = lazy(() => import("@/pages/Privacy"));
const PricingPage = lazy(() => import("@/pages/Pricing"));
const YappyPlaygroundPage = lazy(() => import("@/pages/YappyPlayground"));
const YappyCheckoutPage = lazy(() => import("@/pages/YappyCheckout"));
const NotFoundPage = lazy(() => import("@/pages/NotFound"));
const DashboardLayout = lazy(() => import("@/pages/DashboardLayout"));
const HomePage = lazy(() => import("@/pages/dashboard/Home"));
const UploadPage = lazy(() => import("@/pages/dashboard/Upload"));
const HistoryPage = lazy(() => import("@/pages/dashboard/History"));
const AnalyticsPage = lazy(() => import("@/pages/dashboard/Analytics"));
const SettingsPage = lazy(() => import("@/pages/dashboard/Settings"));
const AdminLayout = lazy(() => import("@/pages/AdminLayout"));
const AdminMonitor = lazy(() => import("@/pages/admin/AdminMonitor"));
const AdminUsers = lazy(() => import("@/pages/admin/AdminUsers"));
export const routes: RouteObject[] = [
{ path: "/login", element: <LoginPage /> },
{ path: "/signup", element: <SignupPage /> },
{ path: "/forgot-password", element: <ForgotPasswordPage /> },
{ path: "/reset-password", element: <ResetPasswordPage /> },
{ path: "/auth/callback", element: <AuthCallbackPage /> },
{ path: "/terms", element: <TermsPage /> },
{ path: "/privacy", element: <PrivacyPage /> },
{ path: "/pricing", element: <PricingPage /> },
{ path: "/yappy", element: <YappyPlaygroundPage /> },
{ path: "/checkout/yappy", element: <YappyCheckoutPage /> },
{
path: "/admin",
element: <AdminLayout />,
children: [
{ index: true, element: <AdminMonitor /> },
{ path: "users", element: <AdminUsers /> },
],
},
{
element: <ProtectedRoute />,
children: [
{ index: true, element: <Navigate to="/dashboard" replace /> },
{
path: "/dashboard",
element: <DashboardLayout />,
children: [
{ index: true, element: <HomePage /> },
{ path: "upload", element: <UploadPage /> },
{ path: "history", element: <HistoryPage /> },
{ path: "analytics", element: <AnalyticsPage /> },
{ path: "settings", element: <SettingsPage /> },
],
},
],
},
{ path: "*", element: <NotFoundPage /> },
];
